define('boxes/helpers/uk-deposit-limit',['jquery', 'boxes/helpers/tooltip', 'all/comeon', 'all/paymentServices-toggles'], function ($, tooltip, comeon, paymentServicesToggles) {
	'use strict';

	var isSetDepositLimitChosen = false;
	var isDepositAmountLimitDiffCorrect = false;
	var isDailyLimitSet = false;

	function depositLimitChosen() {
		return isSetDepositLimitChosen;
	}

	function setIsDepositLimitChosen(isChosen) {
		isSetDepositLimitChosen = isChosen;
	}

	function amountLimitCorrect() {
		return isDepositAmountLimitDiffCorrect;
	}

	function setIsAmountLimitCorrect(isCorrect) {
		isDepositAmountLimitDiffCorrect = isCorrect;
	}

	function shouldShowDepositLimitOption(depositBox) {

		var url = '/UkComplianceService/ukShowDepositLimitOption';
		if (paymentServicesToggles.useOldPaymentFormFlows()) {
			url = '/pp?flow=ResGamingShowDepositLimitOption';
		}

		var shouldShowLimitOptionPromise = comeon.promise.create();
		$.ajax({
			url: url
		}).done(function(result) {
			if (result.JSON_UK_DEPOSIT_SHOW_LIMIT_OPTION === 'YES') {
				showDepositLimitOption(depositBox, true);
			} else {
				showDepositLimitOption(depositBox, false);
			}
			shouldShowLimitOptionPromise.resolve();
		});
		resetLimitAmountField(depositBox);
		return shouldShowLimitOptionPromise.promise();
	}

	function showDepositLimitOption(depositBox, booleanShow) {
		if (booleanShow) {
			depositBox.$box.find('#set-limit').show();
		} else {
			depositBox.$box.find('#set-limit').hide();
		}
		depositBox.$box.find('.daily-limit').hide();
	}

	function setupOnShowDepositLimitClick(depositBox) {
		depositBox.$box.find('#set-limit').find('a').click(function(e) {
			e.preventDefault();
			showDailyLimitField(depositBox, true);
			checkForLimitDepositError(depositBox);
		});
	}

	function setupOnHideDepositLimitClick(depositBox) {
		depositBox.$box.find('#cancel-limit').find('a').click(function(e) {
			e.preventDefault();
			showDailyLimitField(depositBox, false);
		});
	}

	function showDailyLimitField(depositBox, booleanShow) {
		var limitField = depositBox.$box.find('.daily-limit');
		var setLimitButton = depositBox.$box.find('#set-limit');
		if (booleanShow) {
			limitField.show();
			setLimitButton.hide();
		} else {
			limitField.hide();
			setLimitButton.show();
		}
	}

	function resetLimitAmountField(depositBox) {
		var limitInputField = depositBox.$box.find('.daily-limit').find('input[name=set-limit]');
		limitInputField.val('');
	}

	function setupOnInputLimitListener(depositBox) {
		var limitInputField = depositBox.$box.find('.daily-limit').find('input[name=set-limit]');
		limitInputField.on('input', function() {
			checkForLimitDepositError(depositBox);
			checkShouldSetLimit(depositBox);
		});
	}

	function checkShouldSetLimit(depositBox) {
		var limitInputField = depositBox.$box.find('.daily-limit').find('input[name=set-limit]');
		if ($(limitInputField).val() === undefined || $(limitInputField).val() === null || $(limitInputField).val().length === 0) {
			setIsDepositLimitChosen(false);
		} else {
			setIsDepositLimitChosen(true);
		}
		switchDepositButton(depositBox);
	}

	function checkForLimitDepositError(depositBox) {
		var limitInputField = depositBox.$box.find('.daily-limit').find('input[name=set-limit]');
		if ($(limitInputField).val() !== undefined && $(limitInputField).val() !== null && $(limitInputField).val().length !== 0) {
			var amountInputField = depositBox.$box.find('.amount-box input');
			var depositLimit = limitInputField.val();
			var depositAmount = amountInputField.val();
			var amountLimitDiff = depositAmount - depositLimit;
			if (amountLimitDiff > 0) {
				setIsAmountLimitCorrect(false);
				$(limitInputField).parent().addClass('has-error');
				tooltip.showPopover($(limitInputField).parent(), $(limitInputField).parent().data('limit-input-error'));
			} else {
				setIsAmountLimitCorrect(true);
				$(limitInputField).parent().removeClass('has-error');
				tooltip.hidePopover($(limitInputField).parent());
			}
		} else {
			$(limitInputField).parent().removeClass('has-error');
			tooltip.hidePopover($(limitInputField).parent());
		}
	}

	function switchDepositButton(depositBox) {
		var depositButton = depositBox.$box.find('.deposit-button');
		if (depositLimitChosen()) {
			depositButton.html(depositButton.data('limit-deposit'));
		} else {
			depositButton.html(depositButton.data('default'));
		}
	}

	function setDailyLimit(depositBox) {
		if (!isDailyLimitSet) {
			var limitInputField = depositBox.$box.find('.daily-limit').find('input[name=set-limit]');
			var limitValue = limitInputField.val();

			var url = '/UkComplianceService/ukSetResponsibleGamingDepositLimit';
			if (paymentServicesToggles.useOldPaymentFormFlows()) {
				url = '/pp?flow=ResponsibleGamingDepositLimitAdd';
			}

			$.post(url, {depositLimitValue: limitValue, limitType: 'deposit-daily', firstDeposit: 'firstDeposit'});
			isDailyLimitSet = true;
		}
	}

	function validateLimitField() {
		var isValid = true;
		if (depositLimitChosen() && !amountLimitCorrect()) {
			isValid = false;
		}
		return isValid;
	}

	function init(depositBox) {
		setupOnHideDepositLimitClick(depositBox);
		setupOnShowDepositLimitClick(depositBox);
		setupOnInputLimitListener(depositBox);
	}

	return {
		'init' : init,
		'shouldShowDepositLimitOption' : shouldShowDepositLimitOption,
		'depositLimitChosen' : depositLimitChosen,
		'amountLimitCorrect' : amountLimitCorrect,
		'checkForLimitDepositError' : checkForLimitDepositError,
		'setDailyLimit' : setDailyLimit,
		'validateLimitField' : validateLimitField
	};
});

